// 配置项 后期通过远程获取配置

const customerConfig = {
  // 备案号
  IPC: 'ICP备案号：湘ICP备17008777号-3',
  //版权
  copyRight: () => {
    let curYear = new Date().getFullYear();
    return `© 中职星 ${curYear} - ${curYear + 1}`;
  },
  // 系统名称
  systemName: '中职星综合教育平台',
  //练习入口配置
  shortcutList: [
    {
      icon: 'EditOutlined',
      title: '普测练习',
      titleEn: 'College Entrance Examination Practice',
      subTitle: '涵盖中职的各个科目，包括但不限于语文、数学、英语、历史、政治等题目来源需多样化，包括但不限于国家课程标准配套题库、省级或市级教研室提供的题库、历年中高考真题、模拟题、教育合作机构提供的题库等',
      key: 'general',
      colorFrom: '#FFDC90',
      colorTo: '#FDBE29',
      link: '/general'
    },
    {
      icon: 'CalculatorOutlined',
      title: '高考练习',
      titleEn: 'College Entrance Examination Practice',
      subTitle: '涵盖中职的各个科目，包括但不限于语文、数学、英语、历史、政治等题目来源需多样化，包括但不限于国家课程标准配套题库、省级或市级教研室提供的题库、历年中高考真题、模拟题、教育合作机构提供的题库等',
      key: 'collageEntrance',
      colorFrom: '#B9E3F4',
      colorTo: '#77CBED',
      link: '/collage-entrance'
    },
    {
      icon: 'FlagOutlined',
      title: '单招练习',
      titleEn: 'Separate Enrollment Practice',
      subTitle: '涵盖中职的各个科目，包括但不限于语文、数学、英语、历史、政治等题目来源需多样化，包括但不限于国家课程标准配套题库、省级或市级教研室提供的题库、历年中高考真题、模拟题、教育合作机构提供的题库等',
      key: 'separateEnrollment',
      colorFrom: '#FFB9B9',
      colorTo: '#FF7373',
      link: '/separate-enrollment'
    },
    {
      icon: 'ExperimentOutlined',
      title: '在线考试',
      titleEn: 'Online Exam',
      subTitle: '涵盖中职的各个科目，包括但不限于语文、数学、英语、历史、政治等题目来源需多样化，包括但不限于国家课程标准配套题库、省级或市级教研室提供的题库、历年中高考真题、模拟题、教育合作机构提供的题库等',
      key: 'examOnline',
      colorFrom: '#9BE3E0',
      colorTo: '#16A4A7',
      link: '/exam-online'
    },
    {
      icon: 'CodeOutlined',
      title: '在线编程',
      titleEn: 'Online Coding',
      subTitle: '涵盖中职的各个科目，包括但不限于语文、数学、英语、历史、政治等题目来源需多样化，包括但不限于国家课程标准配套题库、省级或市级教研室提供的题库、历年中高考真题、模拟题、教育合作机构提供的题库等',
      key: 'codingOnline',
      colorFrom: '#FFBBBC',
      colorTo: '#C7B4EC',
      link: '/coding-online'
    },
    {
      icon: 'ReadOutlined',
      title: '班级作业',
      titleEn: 'Class Homework',
      subTitle: '涵盖中职的各个科目，包括但不限于语文、数学、英语、历史、政治等题目来源需多样化，包括但不限于国家课程标准配套题库、省级或市级教研室提供的题库、历年中高考真题、模拟题、教育合作机构提供的题库等',
      key: 'homework',
      colorFrom: '#9be089',
      colorTo: '#00D683',
      link: '/homework'
    },

  ],
  titleInfo: [
    // 学生信息配置
    {
      icon: 'UserOutlined',
      title: '学生信息',
      titleEn: 'Student Information',
      subTitle: '管理学生相关信息，包括学籍信息、成绩登记表、学生评价和学生心理健康等',
      key: 'studentInfo',
      colorFrom: '#FEA373',
      colorTo: '#FF678B',
      link: '/student-info'
    },
    // 教师信息配置
    {
      icon: 'UserOutlined',
      title: '教师信息',
      titleEn: 'Teacher Information',
      subTitle: '管理教师相关信息，包括教师档案、教师荣誉以及教师评价等',
      key: 'teacherInfo',
      colorTo: '#9BE3E0',
      colorFrom: '#16A4A7',
      link: '/teacher-info'
    },
    // 组卷作业
    {
      icon: 'PartitionOutlined',
      title: '组卷作业',
      titleEn: 'Paper Composition',
      subTitle: '管理试卷、组合试卷等',
      key: 'paperComposition',
      colorFrom: '#82D1F6',
      colorTo: '#0089CD',
      link: '/paper-info'
    },
    // 心理测评
    {
      icon: 'ExperimentOutlined',
      title: '心理测评',
      titleEn: 'Psychological Assessment',
      subTitle: '涵盖中职的各个科目，包括但不限于语文、数学、英语、历史、政治等题目来源需多样化，包括但不限于国家课程标准配套题库、省级或市级教研室提供的题库、历年中高考真题、模拟题、教育合作机构提供的题库等',
      key: 'psychologicalAssessment',
      colorFrom: '#FEA373',
      colorTo: '#FF678B',
      link: '/student-psychological-assessment'
    },
  ],
  // 政治面貌
  political:[
    {
      "label": "中共党员",
      "value": "中共党员"
    },
    {
      "label": "中共预备党员",
      "value": "中共预备党员"
    },
    {
      "label": "共青团员",
      "value": "共青团员"
    },
    {
      "label": "民主党派",
      "value": "民主党派"
    },
    {
      "label": "无党派人士",
      "value": "无党派人士"
    },
    {
      "label": "群众",
      "value": "群众"
    }
  ],
  // 题型
  topicType:['单选题','多选题','判断题','填空题','简答题','阅读分析'],
}
export default {
  install: (app, options) => {
    // console.log('app, options', app, options);
    app.config.globalProperties.$customerConfig = customerConfig
  }
}
